'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useCurrentDrawInfo } from '../hooks/useCurrentDrawInfo.js';
/**
 * Renders content when the current draw is closed.
 *
 * @param root0 - The props object.
 * @param root0.drawClosedComponent - Content to render when the draw is closed.
 * @param root0.openedDraws - Array of opened draws to check if the current draw is open.
 * @returns The provided content wrapped in a div if the draw is closed, otherwise undefined.
 */
export function DrawClosed({ drawClosedComponent, openedDraws }) {
    const currentDrawInfo = useCurrentDrawInfo();
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const router = useRouter();
    const currentDrawNumber = useRef(currentDrawInfo.drawNumber);
    useEffect(() => {
        const isCurrentDrawOpen = currentDrawNumber.current
            ? openedDraws?.indexOf(currentDrawNumber.current) !== -1
            : false;
        if (!isCurrentDrawOpen) {
            const qs = new URLSearchParams(searchParams.toString());
            // Vilka parametrar ska tas bort vid stängd omgång?
            qs.delete('draw');
            const newUrl = qs.toString() ? `${pathname}?${qs.toString()}` : pathname;
            router.replace(newUrl);
            currentDrawNumber.current = openedDraws?.[0];
        }
    }, [searchParams, pathname, router, openedDraws]);
    if (!drawClosedComponent) {
        return undefined;
    }
    if (!openedDraws) {
        return undefined;
    }
    if (openedDraws.length === 0) {
        return undefined;
    }
    if (currentDrawInfo.drawNumber && openedDraws.indexOf(currentDrawInfo.drawNumber) !== -1) {
        return undefined;
    }
    return _jsx("div", { children: drawClosedComponent });
}
//# sourceMappingURL=DrawClosed.js.map